import { Component, OnInit } from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { MxBaseRestService, MxAlertService } from 'mx-commons';
import { UtilsService } from 'src/app/shared/services/utils.service';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Company } from 'src/app/model/company';
import { SaveService } from 'src/app/shared/services/save.service';
import { isNotNullAndUndefined, isNullOrUndefined } from 'src/app/shared/helpers/utils';
import { StatusResultModalEdit } from 'src/app/shared/services/modal.service';
import { ChangePermission, User } from 'src/app/model/user';
import { LoginService } from '../../login/login.service';
import { debounceTime } from 'rxjs/operators';

@Component({
	selector: 'app-modal-change-permission',
	templateUrl: './modal-change-permission.component.html',
	styleUrls: ['./modal-change-permission.component.scss']
})
export class ModalChangePermissionComponent implements OnInit {

	formGroup: FormGroup;
	data: ChangePermission = null;
	modalService: BsModalService;
	companies: Array<Company> = null;
	users: Array<User> = null;
	success: (resultData: ChangePermission, status: StatusResultModalEdit) => void;

	constructor(private readonly bsModalRef: BsModalRef,
		private readonly restService: MxBaseRestService,
		private readonly utilsService: UtilsService,
		private readonly alertService: MxAlertService,
		private readonly saveService: SaveService,
		private readonly formBuilder: FormBuilder,
		private readonly authService: LoginService) {

	}

	async ngOnInit(): Promise<void> {
		await this.loadCompaniesFromApi();
		if (isNullOrUndefined(this.data)) {
			this.data = new ChangePermission();
		}
		if (this.companies.length === 1) {
			this.data.company = this.companies[0];
			this.loadUsersFromCompany(this.companies[0].id);
		}
		this.createForm();
	}

	private async loadCompaniesFromApi(): Promise<void> {
		this.companies = (await this.restService.getter('companies?active=true', '', '').toPromise())
			.filter(c => this.authService.isPermissionCompany(c.id));
	}

	async loadUsersFromCompany(companyId: string): Promise<void> {
		this.users = await this.restService.getter(`users/from-company/${companyId}`, '', '').toPromise();
	}

	private createForm(): void {
		this.formGroup = this.formBuilder.group(
			{
				companyId: [
					{ value: this.data.company.id, disabled: this.companies.length === 1 || isNotNullAndUndefined(this.data.company.id) },
					Validators.compose([Validators.required])
				],
				userId: [
					this.data.user,
					Validators.compose([Validators.required])
				],
				startDate: [
					this.data.startDate,
					Validators.compose([Validators.required])
				],
				endDate: [
					this.data.endDate,
					Validators.compose([Validators.required])
				]
			}
		);

		const startDate = this.formGroup.get('startDate');
		startDate.valueChanges.subscribe((value: number) => {
			if (isNotNullAndUndefined(value) && value < new Date().getTime()) {
				startDate.setErrors({})
			}
		});
	}

	async save(): Promise<void> {
		try {
			if (this.formGroup.invalid) {
				this.alertService.warning('Dados obrigatórios não informados ou inválidos!');
				this.utilsService.validateAllFormFields(this.formGroup);
				return;
			}
			const dados = { ...this.data, ...this.formGroup.getRawValue() };
			const saved = await this.restService.post('users/permission-temporary', '', dados).toPromise();

			this.alertService.success('Salvo com sucesso!');
			this.formGroup.reset();
			//this.success(saved, StatusResultModalEdit.SAVE);
			this.close();
		} finally {
			this.saveService.saving = false;
		}
	}

	close(): void {
		this.bsModalRef.hide();
	}

	bindLabelCompany(item: Company): string {
		return isNotNullAndUndefined(item) ? `${item.fantasy} - ${item.commercialRegion}` : '';
	}

	bindLabelUser(item: User): string {
		return isNotNullAndUndefined(item) ? `${item.name}` : '';
	}

}